// const apiUrl = 'http://localhost:8080/api'
const apiUrl = 'https://zoeked.com/api'

export const signup = user => {
    // alert(user.name + " : " + user.lastName + " : " + user.companyName + " : " + user.companyType + " : " + user.email + " : " + user.password)
    return fetch(`${apiUrl}/signup`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};

export const signin = user => {
    return fetch(`${apiUrl}/signin`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    })
        .then(response => {            
            return response.json();
        })
        .catch(err => console.log(err));
};

export const authenticate = (data, next) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('jwt', JSON.stringify(data));
        next();
    }
};

export const setName = (name, next) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('username', JSON.stringify(name));
        next();
    }
};

export const signout = next => {    
    if (typeof window !== 'undefined') localStorage.removeItem('jwt');
    next();
    return fetch(`${apiUrl}/signout`, {
        method: 'GET'
    })
        .then(response => {
            // console.log('signout', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const isAuthenticated = () => {
    if (typeof window == 'undefined') {
        alert('hello')
        return false;
    }

    if (localStorage.getItem('jwt')) {
        return JSON.parse(localStorage.getItem('jwt'));
    } else {
        return false;
    }
};

export const forgotPassword = bodyData => {    
    return fetch(`${apiUrl}/forgot-password/`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyData)
    })
        .then(response => {
            // console.log('forgot password response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const resetPassword = resetInfo => {
    // alert(JSON.stringify(resetInfo))
    return fetch(`${apiUrl}/reset-password/`, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(resetInfo)
    })
        .then(response => {
            // console.log('forgot password response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const socialLogin = user => {
    return fetch(`${apiUrl}/social-login/`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        // credentials: "include", // works only in the same origin
        body: JSON.stringify(user)
    })
        .then(response => {
            // console.log('signin response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const linkedInAuth = (formData) => {
    
    return fetch(`${apiUrl}/linkedin-auth`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
        },
        // credentials: "include", // works only in the same origin        
        body: formData
    })
        .then(response => {
            // console.log('signin response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const linkedInDetails = (token) => {
    
    return fetch(`${apiUrl}/linkedin-details`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`
        },
        // credentials: "include", // works only in the same origin        
        form: {}
    })
        .then(response => {
            // console.log('signin response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const linkedInEmail = (token) => {
    
    return fetch(`${apiUrl}/linkedin-email`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`
        },
        form: {}
    })
        .then(response => {
            // console.log('signin response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const linkedInLogin = user => {
    return fetch(`${apiUrl}/linkedin-login/`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        // credentials: "include", // works only in the same origin
        body: JSON.stringify(user)
    })
        .then(response => {
            // console.log('signin response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const linkedInPic = (token) => {
    
    return fetch(`${apiUrl}/linkedIn-pic`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`
        },
        form: {}
    })
        .then(response => {
            // console.log('signin response: ', response);
            return response.json();
        })
        .catch(err => console.log(err));
};

export const signinZendesk = (body) => {

    return fetch(`${apiUrl}/zendesk-auth`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        // credentials: "include", // works only in the same origin        
        body: JSON.stringify(body)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
            console.log(err);
        });
};